import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { App as CapApp } from '@capacitor/app';
import { isNative } from '../utils/platform';

const ROOT_PATHS = new Set(['/', '/login', '/signup', '/home']);

export function useNativeBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isNative) return undefined;

    let listenerHandle;

    CapApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack || window.history.length > 1) {
        if (location.pathname !== '/' && !ROOT_PATHS.has(location.pathname)) {
          navigate(-1);
          return;
        }
      }

      CapApp.exitApp();
    }).then((listener) => {
      listenerHandle = listener;
    });

    return () => {
      listenerHandle?.remove();
    };
  }, [location.pathname, navigate]);
}

export default useNativeBackButton;
